export enum ApprobationEmailDialogFormLabelsEnum {
  TITLE = 'Approval Email',
  SEND = 'Send',
  SKIP = 'Skip',
  CANCEL = 'Cancel',
}
